export class ChatMessageEvent extends Event {
  constructor(name, realTarget) {
    const type = `message-${name}`;
    super(type, {
      bubbles: true,
      composed: true,
    });
    this.realTarget = realTarget;
  }
}
